export const programs = [
  {
    id: 1,
    title: "Community Development",
    description: "Supporting grassroots initiatives that strengthen community infrastructure, collaboration, and access to essential resources.",
    image: "https://images.unsplash.com/photo-1559223607-a43c990c692c",
    icon: "Users",
    details: "We work alongside community members to identify priorities, develop action plans, and implement projects that create lasting positive change. Our approach emphasizes local ownership and sustainable solutions that strengthen community infrastructure and foster collaboration."
  },
  {
    id: 2,
    title: "Youth Empowerment",
    description: "Providing mentorship, skills development, and leadership opportunities to equip young people with tools to succeed and lead positive change.",
    image: "https://images.unsplash.com/photo-1559315558-6fbcbd3cf22d",
    icon: "GraduationCap",
    details: "Young people are at the heart of community transformation. We provide youth with mentorship, skills training, and leadership development opportunities that equip them to become confident leaders and change-makers in their communities."
  },
  {
    id: 3,
    title: "Sustainable Livelihoods",
    description: "Promoting income-generating activities, vocational skills, and entrepreneurship to help individuals achieve economic stability and independence.",
    image: "https://images.unsplash.com/photo-1492496913980-501348b61469",
    icon: "Sprout",
    details: "Economic empowerment is key to community wellbeing. We promote income-generating activities through vocational skills training, entrepreneurship support, and sustainable agricultural practices to help individuals and families achieve economic stability and independence."
  },
  {
    id: 4,
    title: "Local Leadership Development",
    description: "Supporting community leaders with training and resources to drive effective, ethical, and inclusive local development.",
    image: "https://images.unsplash.com/photo-1544806861-dc05b18f6c13",
    icon: "TrendingUp",
    details: "Strong local leadership drives sustainable development. We support community leaders and organizations with training, mentorship, and resources to enhance their effectiveness, promote ethical governance, and drive inclusive local development initiatives."
  }
];

export const values = [
  { title: "Community-First Approach", description: "We work collaboratively with local partners and stakeholders to design solutions that are culturally relevant, practical, and sustainable.", icon: "Heart" },
  { title: "Long-Term Impact", description: "Our programs prioritize long-term impact over short-term interventions by building capacity, strengthening systems, and fostering self-reliance.", icon: "Leaf" },
  { title: "Collaborative Partnership", description: "We take a community-first approach, working with local partners to create solutions that are culturally relevant and sustainable.", icon: "Users" },
  { title: "Transparency & Accountability", description: "We are committed to transparency, accountability, and measurable impact, continuously assessing our programs for effectiveness.", icon: "Shield" }
];

export const contactInfo = {
  email: "info@delinamfoundation.org"
};
export const impactStats = [];
